<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>用户管理</el-breadcrumb-item>
		</el-breadcrumb>

		<!--搜索部分-->
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="用户搜索">
					<el-input v-model="queryKey" placeholder="按用户名搜索">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="getUsers">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="createUser">创建用户</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table border :data="tableData" v-loading="tableLoading" style="width:100%">
			<el-table-column type="index" label="序号" width="70px"></el-table-column>
			<el-table-column prop="workshop_name" label="车间" width="150px"></el-table-column>
			<el-table-column prop="account" label="账号"></el-table-column>
			<el-table-column prop="role" label="用户角色" width="200px"></el-table-column>
			<el-table-column fixed="right" label="操作" width="100px">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
						<el-button slot="reference" type="text" size="small">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!--分页-->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="sizes, prev, pager, next" :total="0"> </el-pagination>

		<!--编辑表单-->
		<el-dialog title="创建用户" :visible.sync="userFormVisible" width="500px">
			<el-form :model="form" ref="userForm" :rules="rules">
				<el-form-item label="登录账号" prop="account" :label-width="formLabelWidth">
					<el-input v-model="form.account" autocomplete="off" placeholder="输入用户登录账号"></el-input>
				</el-form-item>
				<el-form-item label="用户姓名" prop="name" :label-width="formLabelWidth">
					<el-input v-model="form.name" autocomplete="off" placeholder="请输入用户的真实姓名"></el-input>
				</el-form-item>
				<el-form-item label="所在车间" prop="workshop_id" :label-width="formLabelWidth">
					<el-select v-model="form.workshop_id" placeholder="选择所在车间">
						<el-option :label="item.name" :value="item._id.$oid" v-for="item in workshops" :key="item._id.$oid"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户角色" prop="user_rights_group" :label-width="formLabelWidth">
					<el-select v-model="form.user_rights_group" placeholder="选择用户角色">
						<el-option :label="item.value" :value="item.key" v-for="item in roles" :key="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="密码" prop="psw" :label-width="formLabelWidth">
					<el-input placeholder="请输入密码" v-model="form.psw" show-password></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="userFormVisible = false">取消</el-button>
				<el-button type="primary" @click="save('userForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import userRequest from '@/network/requests/user'
	import { workshopRequest } from '@/network/requests/workshop'
	import userService from '@/service/userService'

	export default {
		name: 'userManage',
		data() {
			return {
				pageSize: 10,
				pageIndex: 1,
				queryKey: '',
				currentPage: 5,
				tableData: [],
				tableLoading: false,
				userFormVisible: false,
				editFormVisible: false,
				formLabelWidth: '120px',
				workshops: [],
				form: {},
				roles: [],
				rules: {
					account: [
						{ required: true, message: '请输入登录账号', trigger: 'blur' },
						{ min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' },
					],
					name: [
						{ required: true, message: '请输入用户姓名', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' },
					],
					workshop_id: [{ required: true, message: '请选择车间', trigger: 'change' }],
					user_rights_group: [{ required: true, message: '请选择用户角色', trigger: 'change' }],
					psw: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
				},
			}
		},
		methods: {
			/**
			 * 分页。
			 */
			handleSizeChange(val) {
				this.getUsers()
			},
			/**
			 * 页码切换。
			 */
			handleCurrentChange(val) {
				this.getUsers()
			},
			/**
			 * 创建用户。
			 */
			createUser() {
				this.form = {}
				this.userFormVisible = true
			},
			/**
			 * 保存用户。
			 */
			save(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						userService
							.saveUser(this.form)
							.then(res => {})
							.finally(() => {
								this.userFormVisible = false
								this.getUsers()
							})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
			/**
			 * 获取用户列表。
			 */
			getUsers() {
				userService
					.getUsers(this.pageIndex, this.pageSize, this.queryKey)
					.then(res => {
						this.tableData = res
					})
					.finally(() => {
						this.tableLoading = false
					})
			},
			/**
			 * 编辑用户。
			 */
			handleEdit(row) {
				this.form = { ...row }
				this.userFormVisible = true
			},
			/**
			 * 删除用户。
			 */
			handleDelete(row) {
				userService.deleteUser(row._id.$oid).then(res => {
					this.getUsers()
				})
			},
		},
		created() {
			this.tableLoading = true

			//加载车间。
			workshopRequest.queryAll().then(res => {
				this.workshops = res
			})

			//加载角色。
			userService.getRoleKeyValues().then(res => {
				this.roles = res
			})

			this.getUsers()
		},
	}
</script>

<style scoped></style>
